'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var functionNames = {exports: {}};

exports.functionNames = functionNames;
